import { useState, useCallback } from 'react';

const useChatFilters = () => {
  const [filters, setFilters] = useState({
    report_type: "",
    customer_name: "",
    site_name: "",
    country_name: "",
    part_number: "",
    rig_model: "",
    rig_id: "",
    date_from: "",
    date_to: "",
  });

  const [dropdownOptions, setDropdownOptions] = useState({
    report_type: ["RTC", "CSV", "SA", "RA"],
    customer_name: [],
    site_name: [],
    country_name: [],
    part_number: [],
    rig_model: [],
    rig_id: [],
  });

  const [loadingDropdowns, setLoadingDropdowns] = useState(false);

  //const API_BASE_URL = "http://localhost:8000/api/v1";
  const API_BASE_URL = "https://wa-04-productdatadev.azurewebsites.net/api/v1";
  const apiCall = useCallback(async (endpoint, options = {}) => {
    const token = localStorage.getItem("msal_access_token");
    const defaultOptions = {
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    };

    if (token) {
      defaultOptions.headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...defaultOptions,
      ...options,
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return response;
  }, []);

  const loadDropdownOptions = useCallback(async () => {
    try {
      setLoadingDropdowns(true);
      const response = await apiCall("/filters/options");
      const data = await response.json();
      setDropdownOptions(data);
    } catch (error) {
      console.warn("API dropdown loading failed, using defaults:", error);
    } finally {
      setLoadingDropdowns(false);
    }
  }, [apiCall]);

  const handleFilterChange = useCallback((field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters({
      report_type: "",
      customer_name: "",
      site_name: "",
      country_name: "",
      part_number: "",
      rig_model: "",
      rig_id: "",
      date_from: "",
      date_to: "",
    });
  }, []);

  return {
    filters,
    dropdownOptions,
    loadingDropdowns,
    handleFilterChange,
    clearFilters,
    loadDropdownOptions
  };
};

export default useChatFilters;